import { Button, Modal } from '@/shared/ui'

import { ReviewMediaItem } from '../../model/types'
import { ReviewMediaPreview } from '../media/ReviewMediaPreview'

import styles from './MediaCatalogueModal.module.scss'

type MediaCatalogueModalProps = {
	items: ReviewMediaItem[]
	open: boolean
	onClose: () => void
	onOpenMedia: (index: number) => void
	onLoadMore: () => void
	isLoadingMore: boolean
	hasMore: boolean
}

export const MediaCatalogueModal = ({
	items,
	open,
	onClose,
	onOpenMedia,
	onLoadMore,
	isLoadingMore,
	hasMore
}: MediaCatalogueModalProps) => (
	<Modal contentClassName={styles.mediaCatalogueModal} isOpen={open} onClose={onClose}>
		<header className={styles.mediaCatalogueHeader}>
			<h2>Отзывы</h2>
		</header>
		<div className={styles.mediaCatalogueWrapper}>
			<div className={styles.mediaCatalogueGrid}>
				{items.map((item, index) => (
					<button
						key={item.id}
						type="button"
						className={styles.mediaCatalogueItem}
						onClick={() => {
							onClose()
							onOpenMedia(index)
						}}>
						<ReviewMediaPreview
							className={styles.mediaCataloguePreview}
							src={item.src}
							alt={`Материал покупателя ${index + 1}`}
						/>
					</button>
				))}
			</div>
			{hasMore && (
				<Button
					className={styles.showMoreButton}
					theme="outlined"
					size="L"
					isLoading={isLoadingMore}
					fullWidth
					onClick={onLoadMore}>
					Показать еще
				</Button>
			)}
		</div>
	</Modal>
)
